import {ChecklistModelItemGroup} from './checklistModelItemGroup.model';
import {ChecklistAnswer} from './checklistAnswer.model';

export class ChecklistAnswerGroup {
    id: number;
    checklistModelItemGroup: ChecklistModelItemGroup;
    checklistId: number;
    state: string;
    stateLabel: string;
    targetDate: string;
    completionDate: string;
    itemsCount: number;
    completedCount: number;
    answers: Array<ChecklistAnswer> = [];

    constructor(checklistAnswerGroup: any) {
        if (checklistAnswerGroup) {
            this.id = checklistAnswerGroup.id;
            this.checklistModelItemGroup = new ChecklistModelItemGroup(checklistAnswerGroup.checklistModelItemGroup);
            this.checklistId = checklistAnswerGroup.checklistId;
            this.state = checklistAnswerGroup.state;
            this.stateLabel = checklistAnswerGroup.stateLabel;
            this.targetDate = checklistAnswerGroup.targetDate;
            this.completionDate = checklistAnswerGroup.completionDate;
            this.itemsCount = checklistAnswerGroup.itemCount;
            this.completedCount = checklistAnswerGroup.completedCount;
            if (checklistAnswerGroup.answers) {
                checklistAnswerGroup.answers.forEach(answer => {
                    this.answers.push(new ChecklistAnswer(answer));
                });
            }
        }
    }
}
